import { gql } from '@/__generated__';

const UPDATE_ORGANIZATION_PREFERENCES_INTERFACE = gql(`#graphql
  mutation UpdateOrganizationPreferencesInterface($input: UpdateOrganizationPreferencesInterfaceInput!) {
    updateOrganizationPreferencesInterface(input: $input) {
      id
      defaultIndexRoute
    }
  }
`);

export default UPDATE_ORGANIZATION_PREFERENCES_INTERFACE;
